import { useState } from 'react';

import type { KeyLabelObj } from '@/chat-types/common';
import Dropdown from '@/components/common/dropdown/Dropdown';
import * as SC from '@/components/modal/settings/settings.style';
import type { LanguageCodes } from '@/i18n/index';
import strings, { languageName } from '@/i18n/index';
import useLanguageCodeStore from '@/stores/languageCodeStore';

const Language = () => {
  const languageCodeStore = useLanguageCodeStore();
  const [isOpenLanguageSelect, setIsOpenLanguageSelect] = useState(false);

  const languages = strings.getAvailableLanguages().map((lang) => {
    return { key: lang, label: languageName(lang) };
  }) as Array<KeyLabelObj<LanguageCodes, string>>;

  return (
    <SC.Wrapper>
      <SC.Title>{strings.SETTINGS__LANGUAGE}</SC.Title>
      <div>
        <Dropdown
          selected={{
            key: languageCodeStore.code,
            label: languageName(languageCodeStore.code),
          }}
          wrapperStyle={{ maxWidth: '240px' }}
          hasArrow
          open={isOpenLanguageSelect}
          onClick={() => {
            setIsOpenLanguageSelect((prev) => !prev);
          }}
          items={languages}
          onClickList={(item) => {
            languageCodeStore.changeLanguageCode(item.key);
          }}
        />
      </div>
    </SC.Wrapper>
  );
};

export default Language;
